import NextLink from "common/bit/NextLink"
import { StyledBody2 } from "reusable/wrappers/BodyText"
import styled from "styled-components"
import ButtonType1Icon from "../../../../reusable/icons/ButtonType1Icon"
import ButtonType2Icon from "../../../../reusable/icons/ButtonType2Icon"
import ButtonType3Icon from "../../../../reusable/icons/ButtonType3Icon"

const StyledDiv = styled.div`
  flex: 0 0 50%;
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }

  ${(p) => p.theme.breakpoints.up("md")} {
    :nth-child(n) {
      justify-content: flex-end;
    }

    :nth-child(2n) {
      justify-content: flex-start;
    }
  }
`
const StyledDivWrapper = styled.div`
  width: 280px;
  height: 80px;
  background: ${(p) => p.theme.colors.lightGrey};
  border-radius: 3px;
  display: flex;
  cursor: pointer;
  text-align: center;
  align-items: center;
  justify-content: center;
  svg {
    margin-left: 12px;
  }
  p {
    text-align: center;
  }
  a {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  margin-right: 10px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    &:first-child {
      order: 1;
      margin-top: 20px;
    }
    margin-right: 0px;
    width: 100%;
  }
`

// remove multiple // from url link but not from https://
const removeSlash = (url: string) => {
  const regex = /([^:]\/)\/+/g
  return url.replace(regex, "$1")
}

type DownloadButtonProps = {
  link: string
  name: string
  typeId: number
}

const DownloadButton = ({ link, name, typeId }: DownloadButtonProps) => {
  const SetbtnType = () => {
    if (typeId === 1) return <ButtonType1Icon />
    else if (typeId === 2) return <ButtonType2Icon />
    else if (typeId === 3) return <ButtonType3Icon />
    else return <></>
  }

  const url = removeSlash(link)
  return (
    <StyledDiv>
      <StyledDivWrapper>
        <NextLink href={url} openInNewTab>
          {SetbtnType()}
          <StyledBody2>{name}</StyledBody2>
        </NextLink>
      </StyledDivWrapper>
    </StyledDiv>
  )
}

export default DownloadButton
